import { createElement } from 'react';
import { node, string, bool } from 'prop-types';
import { animatePropTypes, restrictHidePropTypes, animateDefaultProps, restrictDefaultProps } from '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Hidden';
import HiddenContainer from './HiddenContainer.js';
export { default as HiddenContainer, hiddenContainerDefaultProps, hiddenContainerPropTypes } from './HiddenContainer.js';
import _Hidden from './styled.js';
import HiddenShow from './HiddenShow.js';
export { default as HiddenShow, hiddenShowDefaultProps, hiddenShowPropTypes } from './HiddenShow.js';
import HiddenHide from './HiddenHide.js';
export { default as HiddenHide, hiddenHideDefaultProps, hiddenHidePropTypes } from './HiddenHide.js';
import HiddenToggle from './HiddenToggle.js';
export { default as HiddenToggle, hiddenToggleDefaultProps, hiddenTogglePropTypes } from './HiddenToggle.js';

var Hidden = function Hidden(_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "isVisible"]);

  return createElement(_Hidden, _extends({
    visible: isVisible
  }, props), children);
};

Hidden.Container = HiddenContainer;
Hidden.Show = HiddenShow;
Hidden.Hide = HiddenHide;
Hidden.Toggle = HiddenToggle;

var hiddenPropTypes = _objectSpread({}, animatePropTypes, restrictHidePropTypes, {
  children: node.isRequired,
  className: string,
  isVisible: bool
});

Hidden.propTypes = hiddenPropTypes;

var hiddenDefaultProps = _objectSpread({}, animateDefaultProps, restrictDefaultProps, {
  className: undefined,
  isVisible: undefined
});

Hidden.defaultProps = hiddenDefaultProps; // @ts-ignore

var C = Hidden;
export default C;
export { C as Hidden, hiddenDefaultProps, hiddenPropTypes };